import styled from 'styled-components';
export const StyledSubmission = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 3rem;
  align-items: center;
  img {
    width: 15%;
    align-self: flex-end;
  }
  h1 {
    color: #6c757d;
  }

  h2 {
    text-align: center;
  }
  .submission {
    padding-bottom: 1rem;
  }
`;
